export default class BaseMiddleware {
    constructor(parameters = null) {
        this.parameters = parameters
    }
}
